// PayslipPdf.js
import React from "react";
import {
  Document,
  Page,
  Text,
  View,
} from "@react-pdf/renderer";

import { reportStyles, fonts } from "../report-style";
import ReportHeader1 from "../report-header1";
import dayjs from "dayjs";
fonts();
const AttendancePdf = ({ organizationInfo, attendenceSummary, attendenceReportPDFData, attendenceReportInputs }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={reportStyles.page}>
      <View fixed>
        <ReportHeader1 organization_info={organizationInfo} />
        <View style={reportStyles.pdfHeaderTableHeadingwrapper}>
          <Text style={reportStyles.pdfHeaderTableHeading}>
            Attendance Report of {new Date(attendenceReportInputs.report_month).toLocaleString('en-US', { month: 'long', year: 'numeric' })}
          </Text>
        </View>
      </View>

      <View style={reportStyles.pdfHeaderTable}>
        <View style={reportStyles.pdfHeaderTableBx}>
          <View style={reportStyles.HeaderTableBxWrap}>
            <Text>Total Employee:</Text>
            <Text>{attendenceSummary?.total_employee}</Text>
          </View>
          <View style={reportStyles.HeaderTableBxWrap}>
            <Text>Total Salaried Employee:</Text>
            <Text>{attendenceSummary?.total_salaried_employees}</Text>
          </View>
        </View>

        <View style={reportStyles.pdfHeaderTableBx}>
          <View style={reportStyles.HeaderTableBxWrap}>
            <Text>Total Wages Employee:</Text>
            <Text>{attendenceSummary?.total_wages_employees}</Text>
          </View>
          <View style={reportStyles.HeaderTableBxWrap}>
            <Text>Total New Joinee:</Text>
            <Text>{attendenceSummary?.total_new_employees}</Text>
          </View>
        </View>

        <View style={reportStyles.pdfHeaderTableBx}>
          <View style={reportStyles.HeaderTableBxWrap}>
            <Text>Total Left In Service:</Text>
            <Text>{attendenceSummary?.total_left_employees}</Text>
          </View>
          <View style={reportStyles.HeaderTableBxWrap}>
            <Text>Total Leave Count In Whole Month:</Text>
            <Text>{attendenceSummary?.total_on_leave_employee}</Text>
          </View>
        </View>
      </View>
      <View style={reportStyles.ReportTable}>
        {/* Table Header */}
        <View style={reportStyles.ReportTh} fixed>
          <Text style={[reportStyles.ReportHeaderCell, { width: "3%", borderRight: "1px solid #ccc" }]}>
            SL
          </Text>
          <Text style={[reportStyles.ReportHeaderCell, { width: "8%", borderRight: "1px solid #ccc" }]}>
            EMPLOYEE CODE
          </Text>
          <Text style={[reportStyles.ReportHeaderCell, { width: "12%", borderRight: "1px solid #ccc" }]}>
            EMPLOYEE NAME
          </Text>
          <Text style={[reportStyles.ReportHeaderCell, { width: "7%", borderRight: "1px solid #ccc" }]}>
            MONTH DAYS
          </Text>
          <Text style={[reportStyles.ReportHeaderCell, { width: "8%", borderRight: "1px solid #ccc" }]}>
            DECLARED HOLIDAY
          </Text>
          <Text style={[reportStyles.ReportHeaderCell, { width: "7%", borderRight: "1px solid #ccc" }]}>
            WEEKLY OFF
          </Text>
          <Text style={[reportStyles.ReportHeaderCell, { width: "7%", borderRight: "1px solid #ccc" }]}>
            SOW DAYS
          </Text>
          <Text style={[reportStyles.ReportHeaderCell, { width: "7%", borderRight: "1px solid #ccc" }]}>
            PRESENT DAYS
          </Text>

          <View style={[reportStyles.ReportHeaderCell, { width: "15%", borderRight: "1px solid #ccc", padding: "0px" }]}>
            <Text style={[{ borderBottom: "1px solid #ccc", paddingVertical: "2px" }]}>
              LEAVE
            </Text>
            <View style={[reportStyles.ReportHeaderFlex]}>
              <Text style={[reportStyles.ReportHeaderCell,{ borderRight: "1px solid #ccc", width: "15%" }]}>CL</Text>
              <Text style={[reportStyles.ReportHeaderCell,{ borderRight: "1px solid #ccc", width: "15%" }]}>PL</Text>
              <Text style={[reportStyles.ReportHeaderCell,{ borderRight: "1px solid #ccc", width: "15%" }]}>SL</Text>
              <Text style={[reportStyles.ReportHeaderCell,{ width: "55%" }]}>SANCTION LEAVE</Text>
            </View>
          </View>

          <Text style={[reportStyles.ReportHeaderCell, { width: "10%", borderRight: "1px solid #ccc" }]}>
            PAYABLE DAYS
          </Text>
          <Text style={[reportStyles.ReportHeaderCell, { width: "10%", borderRight: "1px solid #ccc" }]}>
            NCP DAYS
          </Text>
          <Text style={[reportStyles.ReportHeaderCell, { width: "15%" }]}>
            REMARKS
          </Text>
        </View>

        {/* Table Body (Dynamic Rows) */}
        {attendenceReportPDFData.map((item, index) => (
          <View key={item.monthly_attendance_id} style={reportStyles.ReportTd} wrap={false}>
            <View style={[reportStyles.ReportTdCell, { width: "3%",  borderRight: "1px solid #ccc" }]}>
              <Text>{index + 1}</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "8%",textAlign:"left", borderRight: "1px solid #ccc" }]}>
              <Text>{item?.employees?.employee_code}</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "12%", borderRight: "1px solid #ccc" }]}>
              <Text>{`${item?.employees?.first_name ?? ""} ${item?.employees?.last_name ?? ""}`.trim() || "N/A"}</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "7%", textAlign:"center", borderRight: "1px solid #ccc" }]}>
              <Text>{item.month_days}</Text>
            </View>
            
            <View style={[reportStyles.ReportTdCell, { width: "8%",textAlign:"center", borderRight: "1px solid #ccc" }]}>
              <Text>{item.declared_holiday}</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "7%",textAlign:"center", borderRight: "1px solid #ccc" }]}>
              <Text>{item.total_weekly_off}</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "7%",textAlign:"center", borderRight: "1px solid #ccc" }]}>
              <Text>{item.scopeOfWorkDays}</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "7%",textAlign:"center", borderRight: "1px solid #ccc" }]}>
              <Text>{item.present_days}</Text>
            </View>

            <View style={[reportStyles.ReportTdCell, { width: "15%", borderRight: "1px solid #ccc", display: "flex", flexDirection: "row", padding: "0px" }]}>
              <View style={{ width: "15%", textAlign:"center", borderRight: "1px solid #ccc", padding: "2px" }}>
                <Text>{item.total_cl}</Text>
              </View>
              <View style={{ width: "15%", textAlign:"center", borderRight: "1px solid #ccc", padding: "2px" }}>
                <Text>{item.total_pl}</Text>
              </View>
              <View style={{ width: "15%", textAlign:"center", borderRight: "1px solid #ccc", padding: "2px" }}>
                <Text>{item.total_sl}</Text>
              </View>
              <View style={{ width: "55%", textAlign:"center",padding: "2px" }}>
                <Text>{item.total_sanction_leave}</Text>
              </View>
            </View>

            <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign:"center", borderRight: "1px solid #ccc" }]}>
              <Text>{item.payable_days}</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "10%", textAlign:"center", borderRight: "1px solid #ccc" }]}>
              <Text>{item.ncp_days}</Text>
            </View>
            <View style={[reportStyles.ReportTdCell, { width: "15%" }]}>
              <Text>
                {(() => {
                  const joinDate = item?.employees?.join_date ? new Date(item.employees.join_date) : null;
                  const exitDate = item?.employees?.exit_formalities?.[0]?.exit_date ? new Date(item.employees.exit_formalities[0].exit_date) : null;
                  const recordMonth = item?.month;
                  const recordYear = item?.year;

                  if (joinDate && joinDate.getMonth() + 1 === recordMonth && joinDate.getFullYear() === recordYear) {
                    return `The Employee joined on ${joinDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
                  }
                  if (exitDate && exitDate.getMonth() + 1 === recordMonth && exitDate.getFullYear() === recordYear) {
                    return `The Employee exited on ${exitDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
                  }
                  return item?.remarks || "--";
                })()}
              </Text>
            </View>
          </View>
        ))}
      </View>
      <View style={reportStyles.footer} fixed>
            <Text>
              Download Time & date: {dayjs().format("DD-MM-YYYY hh:mm A")}{" "}
            </Text>
            <Text
              render={({ pageNumber, totalPages }) =>
                `${pageNumber} / ${totalPages}`
              }
            />
          </View>
    </Page>
  </Document>
);

export default AttendancePdf;
